// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","settings":"_3jYXLlE2A8GsQu2v","title":"_3UuOduXGNByfxseR","subtitle":"_2sWT1OQt6FZ9u4M4","error":"_9wbJhI-G5Two-CKC"};